module.exports = __webpack_public_path__ + "img/lead.0b6b37a4.jpg";